<template>
    <div class="main-container">

        <router-view></router-view>
        <!-- Navbar section -->
        <Navbar />

         <!-- video top section -->
        <Video />

        <!-- best app section -->
        <Bestapp />

        <!-- features section -->
        <Features />

        <!-- footer section -->
        <Footer />

    </div>
</template>

<script>
    import Navbar from '../components/Navbar'
    import Bestapp from '../components/Bestapp'
    import Features from '../components/Features'
    import Video from '../components/Video'
    import Footer from '../components/Footer'

    export default {
        name: 'app',
        components: {
            Navbar,
            Bestapp,
            Features, 
            Video,        
            Footer
        }
    }
</script>

